import React, { useContext, useState } from 'react';
// import { Select } from 'antd';
import Select from 'react-select';
import { getOptionsForAttr } from './coderefs';
import { errorSink } from '../ErrorSink';
import { FormContext } from '../metadata/MDForm';
import { ApplicationActionsContext } from '../data/ApplicationDataSource';
import { formatMoneyAmountNoDecimal } from '../../utils/formatUtils';

const mapAndFormat = (array) => {
  return array.map(
    (value) => `$${formatMoneyAmountNoDecimal(parseInt(value))}`
  );
};

const formatPrevious = (previousValue) => {
  if( !previousValue.includes('-') ) {
    const prevArray = previousValue.split('/');
    const formatted = mapAndFormat(prevArray);
    return `${formatMoneyAmountNoDecimal(formatted)}`;
  } else {
    return previousValue;
  }
};

export const SelectAppUpdater = ({ attr, ...props }) => {
  const options = getOptionsForAttr(attr);
  const form = useContext(FormContext);
  const actions = useContext(ApplicationActionsContext);
  const { setValueByAttr, getValueByAttr } = form;

  const previousValue = getValueByAttr(attr.id);
  const updateInd = !props.disableUpdate;

  const [selectedValue, setSelectedValue] = useState(
    previousValue
      ? {
          value: previousValue,
          label: formatPrevious(previousValue) === '$NaN' ? previousValue : formatPrevious(previousValue),
        }
      : props.value
  );

  let d = props.disabledFlag;
  let disabledFlag = true;
  if (!d){
    disabledFlag = false;
  }

  if (!options || !options.list) {
    return errorSink('no coderefs found for attribute' + JSON.stringify(attr));
  }
  
  const handleChange = (selected) => {
    if (updateInd) {
      setValueByAttr(attr.id, selected.value);
      setSelectedValue(selected);

      // ONEUAT-8123
      let attrId = attr.id;
      if( attrId === 'Line.BILimit' ) {
        let newValue = "Included";
        let splitChange = false;
        if( (selected.value.includes("/") && !previousValue.includes("/")) || (!selected.value.includes("/") && previousValue.includes("/")) ) {
          splitChange = true;
        }
        if ( splitChange ) {
          if( selected.value.includes("/") ) {
            newValue = "100000";
          }
          let pdLimitMapping = form.metadata['Line.PDLimit'].mapping;
          form.setValue(pdLimitMapping,newValue);
          form.touch('Line.PDLimit',false);
          let pdLimitSplitMapping = form.metadata['Line.PDLimitSplit'].mapping;
          form.setValue(pdLimitSplitMapping,newValue);
          form.touch('Line.PDLimitSplit',false);
          if(props.affectUMPD){
              let umpdLimitSplitMapping = form.metadata['Line.SplitUMPDLimit'].mapping;
              form.setValue(umpdLimitSplitMapping,newValue);
              form.touch('Line.SplitUMPDLimit',false);
          }
        }
      }

      // ONEUAT-9325
      if(props.doOnChange){
        props.doOnChange(selected.value);
      }

      // BI change affects UMBI value
      if(attrId == "Line.BILimit" ){
        setValueByAttr("Line.UMBILimit", selected.value);
        if (props.matchBI) {
          setValueByAttr("Line.UIMBILimit", selected.value);
        }
      }

      // UMBI change affects UIMBI value in Kansas, Missouri & Iowa
      if(attrId == "Line.UMBILimit" && props.matchUMBI){
        setValueByAttr("Line.UIMBILimit", selected.value);
      }

      if(attrId == "Line.BFPBLimit" && selected.value != 0 ){
        setValueByAttr("Line.AFPBLimit", "0");
        setValueByAttr("Line.WLBLimit", "0");
        setValueByAttr("Line.FEBLimit", "0");
        setValueByAttr("Line.ADBLimit", "0");
        setValueByAttr("Line.CFPBLimit", "0");
      }

      if(attrId == "Line.AFPBLimit" && selected.value != 0 ){
        setValueByAttr("Line.CFPBLimit", "0");
        setValueByAttr("Line.BFPBLimit", "0");
      }

      if(attrId == "Line.CFPBLimit" && selected.value != 0 ){
        setValueByAttr("Line.BFPBLimit", "0");
        setValueByAttr("Line.AFPBLimit", "0");
        setValueByAttr("Line.WLBLimit", "0");
        setValueByAttr("Line.FEBLimit", "0");
        setValueByAttr("Line.ADBLimit", "0");
      }

      actions.saveApplication();
    }
  };

  const optionsList = options
    ? options.list.map((option) => {
        return {
          value: option.value,
          label: option.name,
        };
      })
    : null;

  // ONEUAT-8123
  var attrId = attr.id;
  var newSelectedValue = selectedValue;
  if( attrId === 'Line.PDLimit' ) {
      newSelectedValue.label = "Included";
      newSelectedValue.value = "0";
  }

  // UMBI options depend on BI
  if(props.newUMBIValue){
    let valToCompare = props.newUMBIValue;

    let attrVal = getValueByAttr(attrId);
    let biVal = getValueByAttr("Line.BILimit");
    valToCompare = biVal;

    if(!valToCompare.includes("/") ) {
      let attrVal = getValueByAttr(attrId);

      if( !biVal.includes("/") ) {
	      for(let i = 0; i < optionsList.length; i++){
	        if(optionsList[i].label.includes("/") || parseInt(optionsList[i].value) > parseInt(valToCompare)){
	  	      optionsList.splice(i,1);
	  	      i = i - 1;
	  	    }
	      }
      }
      for(let i = 0; i < optionsList.length; i++){
  	    if(optionsList[i].value === props.newUMBIValue)
  	      selectedValue.label = optionsList[i].label;
  	  }
  	  if(props.newUMBIValue !== "-1")
      	selectedValue.value = props.newUMBIValue;
      else
      	selectedValue.value = attrVal;
    }else{

      let attrVal = getValueByAttr(attrId);
      const valToCompareArray = valToCompare.split('/');

	  for(let i = 0; i < optionsList.length; i++){
	  	const optionValueArray = optionsList[i].value.split('/') ;

	    if( (!optionsList[i].label.includes("/") && optionsList[i].label !== 'No Coverage' )|| parseInt(optionsList[i].value) > parseInt(valToCompare) ){
	  	  optionsList.splice(i,1);
	  	  i = i - 1;
	  	}else if( ( parseInt(optionValueArray[0]) == parseInt(valToCompareArray[0]) ) && ( parseInt(optionValueArray[1]) > parseInt(valToCompareArray[1]) ) ){
	  	  optionsList.splice(i,1);
	  	  i = i - 1;
	  	}
	  }

	  for(let i = 0; i < optionsList.length; i++){
  	    if(optionsList[i].value === props.newUMBIValue)
  	      selectedValue.label = optionsList[i].label;
  	  }
  	  if(props.newUMBIValue !== "-1")
      	selectedValue.value = props.newUMBIValue;
      else
      	selectedValue.value = attrVal;
    }
  }

  // UIMBI selection depend on UMBI in Kansas
  if(props.newUIMBIValue && props.matchUMBI){
  	let attrVal = getValueByAttr(attrId);
  	for(let i = 0; i < optionsList.length; i++){
      if(optionsList[i].value !== attrVal){
        optionsList.splice(i,1);
        i = i - 1;
      }
    }
  	for(let i = 0; i < optionsList.length; i++){
      if(optionsList[i].value === props.newUIMBIValue || optionsList[i].value === attrVal)
        selectedValue.label = optionsList[i].label;
    }
    if(props.newUIMBIValue !== "-1")
    	selectedValue.value = props.newUIMBIValue;
    else
    	selectedValue.value = attrVal;
    if(props.exclude && optionsList.length == 0){
        optionsList.push({
           value: "0",
           label: "No Coverage",
        });
        selectedValue.label = optionsList[0].label;
        selectedValue.value = optionsList[0].value;
    }
  }

  // ONEUAT-8862
  var excepList = 'Line.NoUMBILimit,Line.NoUIMBILimit,Line.NoUMPDLimit,Line.NoPIP,Line.NoBasicPIP,Line.NoAddedPIP,Line.NoMPLimit,Line.NoReducedbyUMBIInd';
  if( excepList.includes(attrId) ) {
      newSelectedValue = {
        value: "0",
        label: "Not Applicable",
      };
  }
  if( attrId === 'Line.UMBILimit' || attrId === 'Line.UIMBILimit' ) {
  	  if(selectedValue && selectedValue.value == 0 && selectedValue.label !== 'No Coverage'){
          newSelectedValue = {
            value: "100000/300000",
            label: "$100,000/$300,000",
          };
      }
  }
  if( attrId === 'Line.UMPDLimit' ) {
  	  if(selectedValue && selectedValue.value == 0 && selectedValue.label !== 'No Coverage'){
          for(let i = 0; i < optionsList.length; i++){
            let op = optionsList[i];
            if(op.value === "25000" || op.value === "20000") {
              newSelectedValue = op;
            }
          }
      }
  }
  if( attrId === 'Line.PIP' ) {
  	  if(selectedValue && selectedValue.value == 0){
          for(let i = 0; i < optionsList.length; i++){
            let op = optionsList[i];
            if(op.value === "0" && props.zeroDefault) {
              newSelectedValue = op;
              break;
            }
            if(op.value === "40000") {
              newSelectedValue = op;
            }
          }
      }
  }

  if( attrId === 'Line.AddedPIP' ) {
  	  if(selectedValue && selectedValue.value == 0){
          newSelectedValue = {
            value: "0",
            label: "None",
          };
      }
  }

  if( attrId === 'Line.AddlPIP' || attrId === 'Line.OBEL' ) {
      if(selectedValue && selectedValue.value == 0){
          newSelectedValue = {
            value: "0",
            label: "No Coverage",
          };
      }
  }

  if( attrId === 'Line.BasicPIP' ) {
      if(props.fiftyDefault){
        newSelectedValue = {
          value: "50000",
          label: "Included",
        };
      } else {
        if(selectedValue && selectedValue.value == 0){
            newSelectedValue = {
              value: "30000",
              label: "$30,000",
            };
        }
      }
  }

  if( attrId === 'Line.BFPBLimit' ) {
      if(selectedValue && selectedValue.value == undefined){
          newSelectedValue = {
            value: "5000",
            label: "$5,000",
          };
      }
  }

  if(props.value == undefined){
      newSelectedValue = optionsList[0];
  }

  if( attrId === 'Line.BFPBLimit' || attrId === 'Line.AFPBLimit' || attrId === 'Line.WLBLimit' || attrId === 'Line.FEBLimit' || attrId === 'Line.ADBLimit' || attrId === 'Line.CFPBLimit') {
    	let actualVal = getValueByAttr(attrId);
    	if(selectedValue !== undefined){
    	  selectedValue.value = actualVal;
    	  if(selectedValue.value == "2000" && attrId === 'Line.ADBLimit'){
          selectedValue.label = "$2,000 - Included";
        }
    	}
    	if(selectedValue == undefined){
    	  if( attrId === 'Line.BFPBLimit' ) {
    	      newSelectedValue = {
              value: "5000",
              label: "$5,000",
            };
    	  } else {
            newSelectedValue = {
              value: "0",
              label: "No Coverage",
            };
        }
      }
      if(selectedValue && selectedValue.value == "0"){
        newSelectedValue = {
          value: 0,
          label: "No Coverage",
        };
      }
  }

  //ONEUAT-7622
if( attrId === 'Line.BILimit' || attrId === 'Line.UMBILimit' || attrId === 'Line.UIMBILimit' ) {
  	  if(selectedValue && selectedValue.value.includes("/")){
          newSelectedValue = {
            Value: selectedValue.value,
            label: selectedValue.label.replace(",$","/$"),
          };
      } else if(selectedValue.value != "0" && selectedValue.value != "" && !selectedValue.label.includes("CSL")) {
          newSelectedValue = {
            Value: selectedValue.value,
            label: selectedValue.label + " CSL",
          };
      }
  }

  if( attrId === 'Vehicle.CollCoverage' ) {
      if(selectedValue && selectedValue.value == 0){
          newSelectedValue = {
            value: "0",
            label: "No Coverage",
          };
      }
  }

  if(newSelectedValue.Value){
    newSelectedValue.value = newSelectedValue.Value;
  }
  for(let i = 0; i < optionsList.length; i++){
    let op = optionsList[i];
    if(op.value === newSelectedValue.value) {
      newSelectedValue = op;
      break;
    }
  }

  return (
    <div style={{ display: 'inline-block', maxWidth: '158px' }}>
      <Select
        {...props}
        aria-label="Select"
        styles={{ ...customStyles, width: '158px' }}
        title="Select"
        openMenuOnFocus
        placeholder={null}
        options={optionsList}
        value={newSelectedValue}
        onChange={handleChange}
        isDisabled={disabledFlag}
        components={{
          IndicatorSeparator: () => null,
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 4,
          zIndex: 3,
          colors: {
            ...theme.colors,
            primary25: 'rgb(0, 115, 157, 0.1)',
            primary: 'rgba(0, 115, 157, 0.5)',
            neutral30: 'rgba(0, 115, 157, 0.5)',
          },
        })}
      />
    </div>
  );
};

const customStyles = {
  control: (base) => ({
    ...base,
    width: '158px',
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};